import script from "./vipInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./vipInfo.vue?vue&type=script&setup=true&lang=js"

import "./vipInfo.vue?vue&type=style&index=0&id=cb055f3c&lang=less&scoped=true"
import "./vipInfo.vue?vue&type=style&index=1&id=cb055f3c&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb055f3c"]])

export default __exports__